import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
let now = new Date();

export default new Vuex.Store({
  state: {
    list: JSON.parse(localStorage.getItem("list")) || [],
    playing: false,
    timerId: null,
    workRing: JSON.parse(localStorage.getItem("workRing")) || "ring",
    breakRing: JSON.parse(localStorage.getItem("breakRing")) || "alarm",
    tomatoRecord: JSON.parse(localStorage.getItem("tomatoRecord")) || {},
    today: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
    thisWeek: new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - now.getDay()
    )
  },
  mutations: {
    UPDATE_LIST: (state, payload) => {
      switch (payload.type) {
        case "addTask":
          state.list.push(payload.task);
          break;
        case "doneTask":
          for (let i = 0; i < state.list.length; i++) {
            if (state.list[i].id === payload.id) {
              state.list[i].done = true;
              state.list[i].doneTime = new Date();
              break;
            }
          }
          break;
        case "undoneTask":
          for (let i = 0; i < state.list.length; i++) {
            if (state.list[i].id === payload.id) {
              state.list[i].done = false;
              state.list[i].doneTime = null;
              break;
            }
          }
          break;
        case "insertTask":
          for (let i = 0; i < state.list.length; i++) {
            if (state.list[i].id === payload.id) {
              state.list.unshift(state.list.splice(i, 1)[0]);
              break;
            }
          }
          break;
        case "decreaseTime":
          state.list[0].time--;
          break;
        case "startWork":
          state.list[0].working = true;
          state.list[0].time = 25 * 60;
          break;
        case "startBreak":
          state.list[0].working = false;
          state.list[0].time = 5 * 60;
          state.list[0].tomatoAmount++;
          break;
      }
      localStorage.setItem("list", JSON.stringify(state.list));
    },
    UPDATE_PLAYING: (state, playing) => {
      state.playing = playing;
      if (playing === false) {
        localStorage.setItem("list", JSON.stringify(state.list));
      }
    },
    UPDATE_RINGTONE: (state, payload) => {
      if (payload.type === "work") {
        state.workRing = payload.ring;
        localStorage.setItem("workRing", JSON.stringify(state.workRing));
      } else {
        state.breakRing = payload.ring;
        localStorage.setItem("breakRing", JSON.stringify(state.breakRing));
      }
    },
    UPDATE_TIMER_ID: (state, id) => {
      state.timerId = id;
    },
    UPDATE_TOMATO_RECORD: (state, payload) => {
      switch (payload.type) {
        // 將今天以前 done task 記錄到 tomatoRecord 中
        case "filing":
          for (let i = state.list.length - 1; i >= 0; i--) {
            if (
              state.list[i].done === true &&
              state.list[i].doneTime < state.today
            ) {
              // 找到當週的第一天
              let time = state.list[i].doneTime;
              let weekFirstDate = new Date(
                time.getFullYear(),
                time.getMonth(),
                time.getDate() - time.getDay()
              );
              // 用 yyyy/mm/dd 當 key ，放入紀錄中
              let weekKey = `${weekFirstDate.getFullYear()}/${weekFirstDate.getMonth() +
                1}/${weekFirstDate.getDate()}`;
              if (state.tomatoRecord[weekKey]) {
                state.tomatoRecord[weekKey].tomatoAmount[time.getDay()] +=
                  state.list[i].tomatoAmount;
              } else {
                // 將日期陣列放進資料裡
                let dates = [];
                for (let i = 0; i < 7; i++) {
                  let temp = new Date(weekFirstDate.getTime());
                  temp.setDate(temp.getDate() + i);
                  dates.push(temp.getTime());
                }
                state.tomatoRecord[weekKey] = {
                  dates: dates,
                  tomatoAmount: [0, 0, 0, 0, 0, 0, 0]
                };
                state.tomatoRecord[weekKey].tomatoAmount[time.getDay()] +=
                  state.list[i].tomatoAmount;
              }
              // 移除 list 中的資料
              state.list.splice(i, 1);
            }
          }
          localStorage.setItem("list", JSON.stringify(state.list));
          localStorage.setItem(
            "tomatoRecord",
            JSON.stringify(state.tomatoRecord)
          );
          break;
      }
    }
  },
  actions: {
    updateList: (context, payload) => {
      context.commit("UPDATE_LIST", payload);
    },
    updatePlaying: (context, payload) => {
      context.commit("UPDATE_PLAYING", payload);
    },
    updateRingtone: (context, payload) => {
      context.commit("UPDATE_RINGTONE", payload);
    },
    updateTimerID: (context, payload) => {
      context.commit("UPDATE_TIMER_ID", payload);
    },
    updateTomatoRecord: (context, payload) => {
      context.commit("UPDATE_TOMATO_RECORD", payload);
    }
  },
  modules: {}
});
